import { Flow_0_0_2 } from '@flexus/core';

export const BET_105: Flow_0_0_2 = {
	id: '105',
	name: 'no_work_request_assessor',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
